import React, { useState, useEffect, useCallback } from "react";
import { Table, Button, Modal, Form, Row, Col, Card, Badge } from "react-bootstrap";
import "datatables.net-bs5";
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css";
import axios from "axios";
import config from "../../config";
import { toast } from "react-toastify";

export default function PurchaseOrderPayments({ purchaseOrderId }) {
  const [paymentss, setPaymentss] = useState([]);
  const [summary, setSummary] = useState({
    totalAmount: 0,
    totalPaid: 0,
    totalDue: 0,
    paymentStatus: ""
  });
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState({
    date: "",
    amount: "",
    method: "",
    notes: ""
  });

  const [showSummaryModal, setShowSummaryModal] = useState(false);
  const [summaryForm, setSummaryForm] = useState({
    totalAmount: 0,
    paymentStatus: "",
    paymentTerm: ""
  });

  const handleEditSummary = () => {
    setSummaryForm({
      totalAmount: summary.totalAmount,
      paymentStatus: summary.paymentStatus,
      paymentTerm: summary.paymentTerm || ""
    });
    setShowSummaryModal(true);
  };

  const handleSummarySubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${config.API_BASE_URL}/purchase-orders/${purchaseOrderId}/summary`,
        summaryForm
      );
      toast.success("Summary updated");
      setShowSummaryModal(false);
      fetchPayments();
    } catch (err) {
      toast.error("Error updating summary");
    }
  };

  
    const fetchPayments = useCallback(async () => {
      try {
        const res = await axios.get(
          `${config.API_BASE_URL}/purchase-order-payments/${purchaseOrderId}/payments`
        );
        setPaymentss(res.data?.payments || []);
        setSummary(res.data.summary || {
          totalAmount: 0,
          totalPaid: 0,
          totalDue: 0,
          paymentStatus: ""
        });
      } catch (err) {
        console.error('Error fetching payments:', err);
        toast.error("Failed to load payments");
      }
    },[purchaseOrderId]);

  useEffect(() => {
    if (purchaseOrderId) {
      fetchPayments();
    }
  }, [purchaseOrderId, fetchPayments]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${config.API_BASE_URL}/purchase-order-payments/`,
        {
          ...formData,
          purchaseOrderId: purchaseOrderId
        }
      );
      toast.success("Payment added successfully");
      setShowModal(false);
      fetchPayments();
    } catch (err) {
      toast.error("Error adding payment");
    }
  };

  const getPaymentBadge = (status) => {
    const map = {
      "Unpaid": "danger",
      "Partial": "warning",
      "Paid": "success"
    };
    return <Badge bg={map[status] || "secondary"}>{status}</Badge>;
  };

  // useEffect(() => {
  //   // Only initialize DataTable after payments data is loaded
  //   if (paymentss.length >= 0) {
  //     // Destroy existing DataTable if it exists
  //     if ($.fn.dataTable.isDataTable("#pymentsTable")) {
  //       $("#pymentsTable").DataTable().destroy();
  //     }

  //     // Small delay to ensure DOM is updated with new data
  //     setTimeout(() => {
  //       $("#pymentsTable").DataTable({
  //         destroy: true,
  //         responsive: true,
  //         pageLength: 10,
  //         language: {
  //           emptyTable: "No payment records found"
  //         }
  //       });
  //     }, 100);
  //   }
  // }, [paymentss]);
  return (
    <>
      {/* Summary Card */}
      <Card className="mb-3 shadow-sm border-0">
        <Card.Header className="d-flex justify-content-between align-items-center bg-primary text-white">
          <h6 className="mb-0">Payment Summary</h6>
          <Button variant="light" size="sm" onClick={handleEditSummary}>
            <i className="bi bi-pencil"></i> Edit
          </Button>
        </Card.Header>
        <Card.Body>
          <Row className="g-3 text-center">
            <Col xs={6} md={4} lg={2}>
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-currency-rupee fs-4 text-primary"></i>
                <div className="fw-bold text-primary">₹{summary.totalAmount}</div>
                <small className="text-muted">Total Amount</small>
              </div>
            </Col>
            <Col xs={6} md={4} lg={2}>
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-wallet2 fs-4 text-success"></i>
                <div className="fw-bold text-success">₹{summary.totalPaid}</div>
                <small className="text-muted">Total Paid</small>
              </div>
            </Col>
            <Col xs={6} md={4} lg={2}>
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-cash-stack fs-4 text-danger"></i>
                <div className="fw-bold text-danger">₹{summary.totalDue}</div>
                <small className="text-muted">Total Due</small>
              </div>
            </Col>
            <Col xs={6} md={4} lg={3}>
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-check2-circle fs-4 text-info"></i>
                <div className="fw-bold">{getPaymentBadge(summary.paymentStatus)}</div>
                <small className="text-muted">Status</small>
              </div>
            </Col>
            <Col xs={6} md={4} lg={3}>
              <div className="p-3 border rounded bg-light">
                <i className="bi bi-calendar-event fs-4 text-warning"></i>
                <div className="fw-bold">{summary.paymentTerm}</div>
                <small className="text-muted">Payment Term</small>
              </div>
            </Col>
          </Row>
        </Card.Body>
      </Card>



      {/* Payment List Table */}
      <div className="d-flex justify-content-between mb-2">
        <h5>Payment History</h5>
        <Button onClick={() => setShowModal(true)}>Add Payment</Button>
      </div>
      <Table striped bordered hover responsive id="pymentsTable" className=" display responsive mt-4 p-0">
        <thead>
          <tr>
            <th>Date</th>
            <th>Amount</th>
            <th>Method</th>
            <th>Notes</th>
          </tr>
        </thead>
        <tbody>
          {paymentss.map((p, i) => (
            <tr key={i}>
              <td>{new Date(p.date).toLocaleDateString()}</td>
              <td>₹{p.amount}</td>
              <td>{p.method}</td>
              <td>{p.notes}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <Modal show={showSummaryModal} onHide={() => setShowSummaryModal(false)}>
        <Form onSubmit={handleSummarySubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Edit Summary</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group className="mb-3">
              <Form.Label>Total Amount</Form.Label>
              <Form.Control
                type="number"
                value={summaryForm.totalAmount}
                onChange={(e) =>
                  setSummaryForm({ ...summaryForm, totalAmount: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Payment Status</Form.Label>
              <Form.Select
                value={summaryForm.paymentStatus}
                onChange={(e) =>
                  setSummaryForm({ ...summaryForm, paymentStatus: e.target.value })
                }
              >
                <option value="Unpaid">Unpaid</option>
                <option value="Partial">Partial</option>
                <option value="Paid">Paid</option>
              </Form.Select>
            </Form.Group>
            <Form.Group>
              <Form.Label>Payment Term</Form.Label>
              <Form.Control
                type="text"
                value={summaryForm.paymentTerm}
                onChange={(e) =>
                  setSummaryForm({ ...summaryForm, paymentTerm: e.target.value })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowSummaryModal(false)}>Cancel</Button>
            <Button variant="primary" type="submit">Save</Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Add/Edit Payment Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Form onSubmit={handleSubmit}>
          <Modal.Header closeButton>
            <Modal.Title>Add Payment</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={formData.date}
                    onChange={(e) =>
                      setFormData({ ...formData, date: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>Amount</Form.Label>
                  <Form.Control
                    type="number"
                    value={formData.amount}
                    onChange={(e) =>
                      setFormData({ ...formData, amount: e.target.value })
                    }
                    required
                  />
                </Form.Group>
              </Col>
            </Row>
            <Form.Group className="mb-3">
              <Form.Label>Method</Form.Label>
              <Form.Control
                as="select"
                value={formData.method}
                onChange={(e) =>
                  setFormData({ ...formData, method: e.target.value })
                }
                required
              >
                <option value="">Select Method</option>
                <option value="Cash">Cash</option>
                <option value="Bank Transfer">Bank Transfer</option>
                <option value="Cheque">Cheque</option>
                <option value="UPI">UPI</option>
              </Form.Control>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Notes</Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.notes}
                onChange={(e) =>
                  setFormData({ ...formData, notes: e.target.value })
                }
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="primary" type="submit">
              Save Payment
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
}
